import { render, staticRenderFns } from "./tournamentGroup.vue?vue&type=template&id=7343d5ba&scoped=true&"
import script from "./tournamentGroup.vue?vue&type=script&lang=js&"
export * from "./tournamentGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7343d5ba",
  null
  
)

export default component.exports